import React, { useState } from "react";
import { XCircleIcon, CheckCircleIcon } from "@heroicons/react/20/solid";

function WaNotification() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [loadingState, setLoadingState] = useState("0");
  const [, setData] = useState("");
  const [err, setErr] = useState("");
  const API = "https://dev-api.myalice.ai/myalice/whatsapp-notification";

  const notification = [
    {
      title: "WhatsApp Chatbot",
      id: "chatbot",
    },
    {
      title: "WhatsApp Commerce",
      id: "commerce",
    },
    {
      title: "Abandoned Cart Recovery",
      id: "cart",
    },
    {
      title: "Send Shipping Notification",
      id: "shipping",
    },
    {
      title: "Upsell Message",
      id: "upsell",
    },
    {
      title: "Order Confirmation Message",
      id: "order",
    },
    {
      title: "Feedback Messages",
      id: "feedback",
    },
    {
      title: "Generate Creative Campaigns",
      id: "campaign",
    },
  ];
  const [topic, setTopic] = useState(notification[0].id);

  const sendMessage = async () => {
    setLoadingState("1");

    try {
      const response = await fetch(
        API,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone: phone,
            email: email,
            name: name,
            company: company,
            topic: topic,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }

      const result = await response.json();
      setData(result);
    } catch (err) {
      setErr(err.message);
    } finally {
      setLoadingState("2");
    }
  };

  const cleanData = (x) => {
    return x.replace(/[^0-9]/g, "");
  };

  return (
    <div className="min-h-full flex justify-center sm:px-6 lg:px-8">
      <div className="mt-8 max-w-3xl">
        <div className="bg-white py-8 px-4 sm:px-10">
          <div>
            <div>
              <h3 className="text-3xl tracking-wide font-medium text-gray-900 subpixel-antialiased">
              Send yourself a WhatsApp message to experience the power of MyAlice
              </h3>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div className="sm:col-span-6">
                <label
                  htmlFor="notification"
                  className="block text-base font-medium text-gray-900"
                >
                  What type of message do you want?
                </label>
                <select
                  id="notification"
                  name="notification"
                  className="mt-1 block w-full text-base rounded-md border-2 h-14 border-gray-900 focus:border-gray-900 focus:ring-0 focus:shadow focus:shadow-gray-400"
                  defaultValue={notification[0].id}
                  onChange={(e) => setTopic(e.target.value)}
                >
                  {notification.map((x) => (
                    <option key={x.id} value={x.id}>
                      {x.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="sm:col-span-3">
                <label
                  htmlFor="full-name"
                  className="block text-base font-medium text-gray-900"
                >
                  Your Name
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="full-name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoComplete="full-name"
                    placeholder="John Doe"
                    className="block w-full text-base rounded-md border-2 h-14 border-gray-900 focus:border-gray-900 focus:ring-0 focus:shadow focus:shadow-gray-400"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="email"
                  className="block text-base font-medium text-gray-900"
                >
                  Your Email
                </label>
                <div className="mt-1">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    placeholder="you@website.com"
                    className="block w-full text-base rounded-md border-2 h-14 border-gray-900 focus:border-gray-900 focus:ring-0 focus:shadow focus:shadow-gray-400"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="whatsapp"
                  className="block text-base font-medium text-gray-900"
                >
                  WhatsApp Number (with country code)
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="whatsapp"
                    value={phone}
                    onChange={(e) => setPhone(cleanData(e.target.value))}
                    autoComplete="whatsapp"
                    placeholder="6584068880"
                    className="block w-full text-base rounded-md border-2 h-14 border-gray-900 focus:border-gray-900 focus:ring-0 focus:shadow focus:shadow-gray-400"
                  />
                </div>
              </div>

              <div className="sm:col-span-3">
                <label
                  htmlFor="company"
                  className="block text-base font-medium text-gray-900"
                >
                  Company Name or Website
                </label>
                <div className="mt-1">
                  <input
                    type="text"
                    name="company"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    autoComplete="company"
                    placeholder="acme.com"
                    className="block w-full text-base rounded-md border-2 h-14 border-gray-900 focus:border-gray-900 focus:ring-0 focus:shadow focus:shadow-gray-400"
                  />
                </div>
              </div>
            </div>

            <div className="pt-5">
              <div className="flex justify-end">
                {loadingState === "0" ? (
                  <button
                    type="button"
                    onClick={sendMessage}
                    className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-primary py-3.5 px-5 text-base font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none"
                  >
                    Send WhatsApp Notification
                  </button>
                ) : loadingState === "1" ? (
                  <button
                    type="button"
                    disabled
                    className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-400 py-3.5 px-5 text-base font-medium text-white shadow-sm focus:outline-none"
                  >
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Sending Now...
                  </button>
                ) : err ? (
                  <div className="rounded-md bg-red-50 p-4 w-full">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <XCircleIcon
                          className="h-5 w-5 text-red-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="ml-3 flex-1 md:flex md:justify-between">
                        <p className="text-base font-medium text-red-800">
                          Failed to sent notification
                        </p>
                        <p className="mt-3 text-sm md:mt-0 md:ml-6">
                          <span
                            onClick={() => {
                              setErr("");
                              setLoadingState("0");
                            }}
                            className="whitespace-nowrap text-base font-medium text-red-700 hover:text-red-600 underline cursor-pointer"
                          >
                            Try Again
                            <span aria-hidden="true"> &rarr;</span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="rounded-md bg-green-50 p-4 w-full">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <CheckCircleIcon
                          className="h-5 w-5 text-green-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="ml-3 flex-1 md:flex md:justify-between">
                        <p className="text-base font-medium text-green-800">
                          WhatsApp Notification sent to {phone}
                        </p>
                        <p className="mt-3 text-sm md:mt-0 md:ml-6">
                          <span
                            onClick={() => {
                              setErr("");
                              setLoadingState("0");
                            }}
                            className="whitespace-nowrap text-base font-medium text-green-700 hover:text-green-600 underline cursor-pointer"
                          >
                            Go Back
                            <span aria-hidden="true"> &rarr;</span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WaNotification;
